import moment from 'moment'
import EventEmitter from 'events'

export function createCountdown(targetTimestamp, format = 'HH:mm:ss') {
    const emitter = new EventEmitter()
    let intervalID = null

    const tick = () => {
        if (!targetTimestamp) {
            emitter.emit('tick', null)
            return
        }

        const now = moment()
        const target = moment(targetTimestamp)

        if (!target.isAfter(now)) {
            emitter.emit('tick', null)
            return
        }

        const totalSeconds = Math.floor(target.diff(now) / 1000)
        const formatted = moment.utc(totalSeconds * 1000).format(format)
        const [hours, mins, secs] = formatted.split(':')

        emitter.emit('tick', { hours, mins, secs })
    }

    return {
        emitter,
        start() {
            if (intervalID) return
            tick()
            intervalID = setInterval(tick, 1000)
        },
        stop() {
            if (intervalID) {
                clearInterval(intervalID)
                intervalID = null
            }
        }
    }
}